import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const InlineError = /*#__PURE__*/ memo((param)=>{
    let { error, "data-testid": testId } = param;
    if (!error) {
        return null;
    }
    return /*#__PURE__*/ _jsx("p", {
        "data-testid": testId,
        className: "absolute -bottom-1.5 right-4 bg-grey-1 px-2 py-0.5 text-10 font-medium text-red-9",
        children: error
    });
});
InlineError.displayName = "InlineError";
